module.exports = __webpack_public_path__ + "static/media/imgn_partesdelgrano.aeed49c9.jpg";